import axiosInstance from './../providers/Axios';

import { addressBase } from '../config/paths';

export const callCreateUserAddress = async (newAddress, userId) => {
  return axiosInstance({
    url: `${addressBase}/${userId}/addresses/`,
    method: 'post',
    data: newAddress,
  });
};

export const callEditUserAddress = async (address, userId) => {
  return axiosInstance({
    url: `${addressBase}/${userId}/addresses/${encodeURIComponent(
      address.nickName,
    )}`,
    method: 'put',
    data: address,
  });
};

export const callDeleteUserAddress = async (userId, addressNickname) => {
  return axiosInstance({
    url: `${addressBase}/${userId}/addresses/${encodeURIComponent(
      addressNickname,
    )}`,
    method: 'delete',
  });
};
